// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__L4jFQ","file":"styles_file___--5i"};